export const getFileFormat = (acceptedTypes, fileType = '') => {
  if (!acceptedTypes) return '';
  if (['gif', 'jpg', 'png', 'jpeg'].includes(fileType)) return `image/${fileType}`;
  if (!acceptedTypes.includes('pdf')) return 'image';
  return 'pdf';
};
